<style>
@import '../custom/css/sobre.css';
</style>

<template>
  <section class="sobre">
    <div class="head-banner">
      <div class="box-img">
        <img
          class="img-fluid obj h-100"
          src="@/assets/img/banner-head-100.jpg"
          alt="Banner Promoção"
        />
      </div>
    </div>
    <div class="quem-somos pb-100">
      <div class="container">
        <!-- Breadcrumb -->
        <div class="row p-25">
          <div class="col-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link class="text-uppercase" :to="{ name: 'home' }"
                    >Início</router-link
                  >
                </li>
                <li
                  class="breadcrumb-item active text-uppercase"
                  aria-current="page"
                >
                  Sobre
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <!--  Quem Somos Conteúdo -->
        <!--  TODO: Seria bacana deixar essa info no BD -->
        <div class="row">
          <div class="col-md-6 mb-md-0 mb-5">
            <h1 class="h1-after text-uppercase fwb mb-4">Quem Somos</h1>
            <p class="roboto-n fs-14 mb-2">
              Somos uma empresa que visa trazer facilidade para sua obra,
              apresentando as melhores cotações de materiais de construções sem
              perder tempo e dinheiro. Oferecemos orçamentos de empresas
              parceiras da Constr Up, sem a necessidade de contatá-las
              pessoalmente, pois reconhecemos que fator tempo é importante para
              todos, e não podemos desperdiça-lo visitando todas as lojas
              físicas, em busca do melhor preço, forma de pagamento e prazo de
              entrega.
            </p>
            <p class="roboto-n fs-14 mb-2">
              Acreditamos que podemos mudar o pensamento de quem já iniciou uma
              obra e diz não querer nunca mais construir novamente. Pois de
              fato, existem muitas dificuldades e transtornos, sendo elas: as de
              encontrar pessoas qualificadas para atender as necessidades de sua
              construção, o dinheiro e o tempo gasto para escolher o lugar certo
              para comprar os materiais de sua obra.
            </p>
            <p class="roboto-n fs-14">
              Diante de todos esses fatores, criamos a Constr Up que veio por
              meio da facilidade que a tecnologia vem trazendo facilitar a
              resoluções desses problemas diretamente do conforto de sua casa ou
              de onde estiver de um jeito rápido e fácil e o mais importante
              gratuitamente!
            </p>
          </div>
          <div class="col-md-6">
            <div class="box-img shadow">
              <img
                class="img-fluid obj"
                src="@/assets/img/quem-somos-img-100.jpg"
                alt
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ServicesOffered />
    <NewsLetter />
  </section>
</template>

<script>
import ServicesOffered from '../components/ServicesOffered.vue';
import NewsLetter from '../components/NewsLetter.vue';

export default {
  components: {
    ServicesOffered,
    NewsLetter,
  },
  data() {
    return {
      receber: {
        email: null,
        nome: null,
        enviado: 'contato@construp.com.br',
      },
    };
  },
};
</script>
